import { Reducer } from "redux";

import { CurrenciesAction, CurrenciesActionTypes, CurrenciesState, defaultCurrency } from "./types";

const initialState: CurrenciesState = {
  selectedCurrency: defaultCurrency,
};

const reducer: Reducer<CurrenciesState, CurrenciesAction> = (state = initialState, action) => {
  switch (action.type) {
    case CurrenciesActionTypes.SELECT: {
      const { currency } = action.payload;
      return { ...state, selectedCurrency: currency };
    }

    default:
      return state;
  }
};

export default reducer;
